var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-field--wrapper"},[_c('validation-template',{attrs:{"validation":_vm.validation,"manualValidation":_vm.manualValidation,"hide-validation":_vm.hideValidation}},[_c('v-textarea',_vm._g(_vm._b({attrs:{"attach":"","hide-details":"auto"},on:{"blur":_vm.updateValidation}},'v-textarea',_vm.$attrs,false),_vm.$listeners))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }